import { render, staticRenderFns } from "./blayer.vue?vue&type=template&id=5086a996&scoped=true"
import script from "./blayer.vue?vue&type=script&lang=js"
export * from "./blayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5086a996",
  null
  
)

export default component.exports